import { baseAPI } from "../BaseAPI";

export interface AskAmiSharedResource {
  resourceName: string;
  resourceUrl: string;
  resourceType: string;
}

export const landingPageResourcesAPI = baseAPI.injectEndpoints({
  endpoints: (build) => ({
    getLandingPageResources: build.query<AskAmiSharedResource[], void>({
      query: () => "shared-resources",
    }),
  }),
  overrideExisting: false,
});

export const { useGetLandingPageResourcesQuery } = landingPageResourcesAPI;